import MasterCardImgFlipTote from "../components/MasterCardImgFlipTote";


const ToteBag = () => {
    return (
      <MasterCardImgFlipTote />
    );
}

export default ToteBag;